import { render } from "./Wheel5.vue?vue&type=template&id=7ab17ca0"
import script from "./Wheel5.vue?vue&type=script&lang=js"
export * from "./Wheel5.vue?vue&type=script&lang=js"
script.render = render

export default script